import _, { escapeRegExp, isString } from 'lodash';

/**
 * Creates a function that takes a schedule item and returns true if the item
 * matches all the filter conditions. The function returned is memoized.
 *
 * @param {object} filter Filter object
 * @param {string} filter.text Filter text
 * @param {object} filter.categories Filter categories object
 * @returns Function that takes a schedule item and returns true if the item matches the filter
 */
export function createFilter(filter) {
    if (!filter) {
        console.error('filter is required');
        return () => false;
    }

    const { text, categories } = filter,
        filters = [];

    if (text && isString(text)) {
        const wordsExps = text.split(/\W/).map((word) => new RegExp(escapeRegExp(word), 'i'));

        for (let propName of ['name', 'description']) {
            filters.push((session) => {
                return !wordsExps.some((exp) => !session[propName]?.match(exp));
            });
        }
    }

    if (categories) {
        for (let category of Object.keys(categories)) {
            filters.push((item) => {
                let itemCategories = _(item)
                    .chain()
                    .get('categories', [])
                    .find((cat) => cat.name == category)
                    .get('options', [])
                    .value();
                return _.intersection(itemCategories, categories[category]).length;
            });
        }
    }

    // If no filters are defined, return true
    if (!filters.length) return () => true;

    return (session) => {
        const result = filters.some((f) => f(session));
        return result;
    };
}
